const popup = document.querySelector(".na-popup-msg");
const popupPName = popup.querySelector(".p-name");
const svgs = popup.querySelectorAll("svg");
let timeoutID;

function triggerPopup({ message, status }) {
  if (timeoutID !== undefined) {
    clearTimeout(timeoutID);
  }
  svgs.forEach((svg) => svg.classList.remove("active"));
  popup.querySelector(`.${status}`).classList.add("active");
  popup.style.animation = "none";
  popup.offsetHeight; /* trigger reflow */
  popup.style.animation = null;

  popup.classList.add("active");
  popupPName.innerText = message;
  timeoutID = setTimeout(() => {
    popup.classList.remove("active");
  }, 1500);
}
